// extracted by mini-css-extract-plugin
module.exports = {"section17":"Section17_section17__aygjM"};